// extracted by mini-css-extract-plugin
export default {"pricesContainer":"styles_pricesContainer__EgVX9"};